module.exports = __webpack_public_path__ + "static/media/students.9a5e4549.jpg";